// src/services/storiesApiService.ts
import axios from 'axios'
import { getApiBaseUrl } from '@/utils/basePath'

export interface StoryApiDto {
  id: string
  title: string | Record<string, string>
  content?: string | Record<string, string>
  videoUrl?: string | Record<string, string> | null
  imageUrl?: string | Record<string, string> | null // Keep for backward compatibility
  region: string
  language: string
  isPinned: boolean
  createdAt: string
}

const api = axios.create({
  baseURL: getApiBaseUrl(),
})

// Update baseURL on each request
api.interceptors.request.use((config) => {
  config.baseURL = getApiBaseUrl()
  return config
})

class StoriesApiService {
  async getStories(params?: {
    region?: string
    language?: string
    search?: string
  }): Promise<StoryApiDto[]> {
    const res = await api.get<StoryApiDto[]>('/Stories', {
      params,
    })
    return res.data
  }

  async getLatest(count = 10): Promise<StoryApiDto[]> {
    const res = await api.get<StoryApiDto[]>('/Stories/latest', {
      params: { count },
    })
    return res.data
  }
}

export const storiesApi = new StoriesApiService()
